export { default as mutationPush } from './mutationPush'
export { default as mutationPushAll } from './mutationPushAll'
